import {
  IconAperture,
  IconPoint,
  IconBoxMultiple

} from '@tabler/icons';
import { uniqueId } from 'lodash';
import DescriptionIcon from '@mui/icons-material/Description';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import MarkUnreadChatAltOutlinedIcon from '@mui/icons-material/MarkUnreadChatAltOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

const Menuitems = [
  // {
  //   id: uniqueId(),
  //   title: 'Sample Page',
  //   icon: IconAperture,
  //   href: '/sample-page',
  //   chip: 'New',
  //   chipColor: 'secondary',
  // },
  // {
  //   id: uniqueId(),
  //   title: 'Menu Level',
  //   icon: IconBoxMultiple,
  //   href: '/menulevel/',
  //   children: [
  //     {
  //       id: uniqueId(),
  //       title: 'Level 1',
  //       icon: IconPoint,
  //       href: '/l1',
  //     },
  //     {
  //       id: uniqueId(),
  //       title: 'Level 1.1',
  //       icon: IconPoint,
  //       href: '/l1.1',
  //       children: [
  //         {
  //           id: uniqueId(),
  //           title: 'Level 2',
  //           icon: IconPoint,
  //           href: '/l2',
  //         },
  //         {
  //           id: uniqueId(),
  //           title: 'Level 2.1',
  //           icon: IconPoint,
  //           href: '/l2.1',
  //           children: [
  //             {
  //               id: uniqueId(),
  //               title: 'Level 3',
  //               icon: IconPoint,
  //               href: '/l3',
  //             },
  //             {
  //               id: uniqueId(),
  //               title: 'Level 3.1',
  //               icon: IconPoint,
  //               href: '/l3.1',
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    id: uniqueId(),
    title: 'Buy Naw',
    icon: PeopleOutlineIcon,
    href: `/buy`,
    // chip: 'New',
    // chipColor: 'secondary',
  },
  {
    id: uniqueId(),
    title: 'Application',
    icon: DashboardCustomizeOutlinedIcon,
    href: `/application`,
    // chip: 'New',
    // chipColor: 'secondary',
  },
  {
    id: uniqueId(),
    title: 'Ingredients',
    icon: MarkUnreadChatAltOutlinedIcon,
    href: `/ingredients`,
    // chip: 'New',
    // chipColor: 'secondary',
  },
  {
    id: uniqueId(),
    title: 'Return',
    icon: StorefrontOutlinedIcon,
    href: `/return`,
    // chip: 'New',
    // chipColor: 'secondary',
  },
  {
    id: uniqueId(),
    title: 'Contact',
    icon: AssessmentOutlinedIcon,
    href: `/contact`,
    // chip: 'New',
    // chipColor: 'secondary',
  },
];
export default Menuitems;
